import { z } from 'zod/v4'

export const CreateFieldDefinitionOptionSchema = z.object({
  label: z.string().min(1),
  value: z.string().min(1),
  icon: z.string().optional().nullable(),
  // Allow hex colors (#RRGGBB, #RGB) or color names (red, green, blue, yellow, etc.)
  color: z.string().optional().nullable(),
})

export const UpdateFieldDefinitionOptionSchema =
  CreateFieldDefinitionOptionSchema.extend({
    id: z.string(),
  }).omit({
    value: true,
  })

export const GetFieldDefinitionOptionSchema =
  CreateFieldDefinitionOptionSchema.extend({
    id: z.string(),
  })
